






























































































































import {
    Component,
    Vue,
    Prop
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import DieselLocomotive from '@/models/Locomotives/DieselLocomotive'
import DieselLocoSection from '../models/Locomotives/DieselLocoSection'

@Component
export default class DieselLocomotivePanelRow extends Vue {
    
    @Prop({
        type: Object,
        required: true
    })
    locomotive!: DieselLocomotive

    private roundedValue(value: string): string {
        return parseFloat(value).toFixed(2)
    }
    private sectionIsOn(locoSection: DieselLocoSection): boolean {
        return locoSection.generatorFrequencyPerMinute > 0
    }
    private getEngineValue(locomotive: DieselLocomotive, property: string): string {
        const activeSection = locomotive.locoSections.filter((ls) => this.sectionIsOn(ls))[0]

        if (activeSection == null) {
            return '-'
        }

        const value = (activeSection as any)[property]

        if (value == 1) {
            return 'Да'
        }
        return 'Нет'
    }
}
